import { type InsuranceCorporateIdentity } from "../types";

export function SBKLogo({ className }: { className?: string }) {
  return (
    <svg
      width="512"
      height="512"
      viewBox="0 0 512 512"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M212.303 177.565C212.303 201.13 231.868 220 256.042 220C280.216 220 299.868 201.13 299.868 177.565C299.868 154 280.303 135.13 256.042 135.13C231.781 135.13 212.303 154 212.303 177.565ZM270.999 177.565C270.999 185.826 264.39 192.521 256.042 192.521C247.694 192.521 241.086 185.913 241.086 177.565C241.086 169.217 247.694 162.608 256.042 162.608C264.39 162.608 270.999 169.217 270.999 177.565Z"
        fill="white"
      />
      <path
        d="M256.131 78.087C156.913 78.087 77 158 77 257.217C77 347.739 143.696 422.087 231.261 434L343.087 322.174C365.348 299.913 366.304 266.087 344.739 244.522C323.174 222.609 288.044 223.913 267.087 247.217L256.131 259.304L245.174 247.217C223.957 224 189.435 222.696 167.522 244.522C145.957 266.087 147 299.913 169.174 322.174L205.348 358.696L230.913 333.13L194.391 296.957C186.13 288.696 185.435 277.739 193.087 270.087C200.739 262.435 211.348 263.13 219.957 271.739L256.131 307.913L292.304 271.739C300.565 263.478 311.522 262.783 319.174 270.087C326.826 277.391 326.13 288.696 317.87 296.957L219.174 395.391C159.87 378.783 116.217 323.304 116.217 257.13C116.217 177.826 178.913 113.826 256.913 113.826C334.913 113.826 396.217 177.217 396.217 257.13C396.217 303.565 381.609 334.435 340.826 375.217L284.391 431.304C373.609 419.652 435.348 350.348 435.348 257.13C435.348 157.913 355.435 78 256.217 78"
        fill="white"
      />
    </svg>
  );
}

export const SBK: InsuranceCorporateIdentity = {
  id: "sbk",
  name: "SBK Siemens-Betriebskrankenkasse",
  logo: SBKLogo,
  backgroundColor: "#003C6E",
  textColor: "#FFFFFF",
  wildcard: { or: ["sbk", "siemens"] },
  type: "statutory",
};
